module.exports = __webpack_public_path__ + "static/media/9. Rr7, Superficie sólida, 33 x 53 x 20 cm, 2020 copy.91cd2beb.png";